const makeConstant = constant => `user/${constant}`

export const PATCH_USER_PROPERTIES = makeConstant('PATCH_USER_PROPERTIES')
export const PATCH_USER_PROPERTIES_PENDING = makeConstant('PATCH_USER_PROPERTIES_PENDING')
export const PATCH_USER_PROPERTIES_SUCCESS = makeConstant('PATCH_USER_PROPERTIES_SUCCESS')
export const PATCH_USER_PROPERTIES_FAILED = makeConstant('PATCH_USER_PROPERTIES_FAILED')

